/* eslint-disable no-undef */
import { mapGetters } from 'vuex'
var ga4 = {
  computed: {
    ...mapGetters([
      'user'
    ])
  },
  methods: {
    return_item (value) {
      if (!Array.isArray(value)) {
        let newItems = [{
          item_id: value.id,
          item_name: value.name,
          discount: value.discount,
          quantity: 1,
          price: value.pricing,
          item_category: value.type,
          item_list_id: value.category_id
        }]

        return newItems
      } else {
        let newItems = []
        for (let item of value) {
          newItems.push({
            item_id: item.id,
            item_name: item.name,
            discount: item.discount ? item.discount : '',
            quantity: item.quantity ? item.quantity : 1,
            price: item.pricing,
            item_category: item.type,
            item_list_id: item.category_id ? item.category_id : ''
          })
        }

        return newItems
      }
    },

    add_payment_info (item) {
      // 這個事件代表使用者是在電子商務結帳程序中提交付款資訊。
      let self = this
      gtag('event', 'add_payment_info', {
        currency: 'TWD',
        value: item.pricing,
        payment_type: self.paymentInfo.payment,
        items: self.return_item(item)
      })
    },

    add_shipping_info (item) {
      // 這個事件表示使用者是透過電子商務結帳程序提交運送資訊。
      let self = this
      gtag('event', 'add_shipping_info', {
        currency: 'TWD',
        value: item.pricing,
        shipping_tier: self.paymentInfo.payment,
        items: self.return_item(item)
      })
    },

    add_to_cart (item) {
      // 這個事件代表商品已加入購物車，
      let self = this
      gtag('event', 'add_to_cart', {
        currency: 'TWD',
        value: item.pricing,
        items: self.return_item(item)
      })
    },

    add_to_wishlist (data) {
      // 事件表示項目已加入願望清單。使用這個事件來識別應用程式中的熱門禮物。
      let self = this
      gtag('event', 'add_to_wishlist', {
        currency: 'TWD',
        value: data.pricing,
        items: self.return_item(data)
      })
    },

    begin_checkout (data) {
      // 這類事件表示使用者已開始結帳。
      let self = this
      gtag('event', 'begin_checkout', {
        currency: 'TWD',
        value: data.total,
        coupon: self.paymentInfo.couponCode,
        items: self.return_item(data)
      })
    },

    purchase_track (orderData, products) {
      // 這類事件會在使用者購買一或多項商品時進行通知。
      let self = this

      let obj = {
        transaction_id: orderData.order_id,
        value: self.total,
        shipping: self.paymentInfo.shipping_fee,
        currency: 'TWD',
        coupon: self.paymentInfo.couponCode,
        items: self.return_item(products)
      }
      gtag('event', 'purchase', obj)
    },

    remove_from_cart (item) {
      // 這個事件表示商品已從購物車中移除。
      let self = this
      gtag('event', 'remove_from_cart', {
        currency: 'TWD',
        value: item.pricing,
        items: self.return_item(item)
      })
    },

    search_track (keyword) {
      // 記錄這個事件以判斷使用者何時進行搜尋。
      gtag('event', 'search', {
        search_term: keyword
      })
    },

    view_cart (data) {
      // 這個事件表示使用者查看了購物車。
      if (JSON.parse(localStorage.getItem('products'))) {
        let self = this
        gtag('event', 'view_cart', {
          currency: 'TWD',
          value: data.total,
          items: self.return_item(data.items)
        })
      }
    },

    view_item (data) {
      // 此事件代表使用者已經看到部分內容。使用這個事件探索最受歡迎的項目。
      let self = this
      gtag('event', 'view_item', {
        currency: 'TWD',
        value: data.pricing,
        items: self.return_item(data)
      })
    },

    view_item_list (dataObj, data) {
      let self = this
      gtag('event', 'view_item_list', {
        item_list_id: dataObj.category ? dataObj.category : '',
        item_list_name: dataObj.type,
        items: self.return_item(data.data)
      })
    },

    login_track () {
      let self = this
      // 傳送這個事件，表示使用者已經登入網站或應用程式。
      if (!self.user) return
      gtag('config', 'G-5VCP96RG47', {
        user_id: self.user.id,
        method: 'Website'
      })
      gtag('event', 'login', {
        method: 'Website'
      })
    },

    sign_up_track () {
      // 這個事件表示使用者已申請帳戶，透過這個事件，瞭解已登入和未登入使用者的行為。
      let self = this
      gtag('event', 'sign_up', {
        user_id: self.user.id,
        method: 'Website'
      })
    },

    select_promotion (data) {
      // 此事件表示已在清單中選取活動。
      // let self = this
      gtag('event', 'select_promotion', {
        promotion_id: data.id,
        promotion_name: data.name
      })
    }
  }
}

export default ga4
